import { Select, TextInput } from "@normasteaching/norma-ui";
import { phoneCountryCodeList } from "../HeyLight/phoneCountryCodeList.ts";

export type PhoneNumberDTO = {
  countryCode: string;
  dialCode: string;
  number: string;
};

class CountryCodeId {
  constructor(
    public readonly dialCode: string,
    public readonly letterCountryCode: string,
  ) {}

  toString(): string {
    return `${this.dialCode}|${this.letterCountryCode}`;
  }

  static fromString(value: string): CountryCodeId {
    const [dial_code, code] = value.split("|");
    return new CountryCodeId(dial_code, code);
  }
}

type Props = {
  value?: PhoneNumberDTO;
  onChange: (value: PhoneNumberDTO) => void;
  onNumberChange?: () => void;
  errorMessage?: string;
};

export function CheckoutPhoneInput({
  value,
  onChange,
  onNumberChange,
  errorMessage,
}: Props) {
  function createEmptyValue(): PhoneNumberDTO {
    return { number: "", countryCode: "", dialCode: "" };
  }

  return (
    <div className={"space-y-2"}>
      <div className={"flex items-start space-x-2"}>
        <div className={"w-32 shrink-0"}>
          <Select<string>
            searchable
            value={
              value
                ? new CountryCodeId(
                    value.dialCode.replace("+", ""),
                    value.countryCode,
                  ).toString()
                : undefined
            }
            renderLabel={(option) =>
              `+${CountryCodeId.fromString(option.id).dialCode}`
            }
            options={[...phoneCountryCodeList]
              .sort((a, b) => parseInt(a.code) - parseInt(b.code))
              .map((code) => ({
                id: new CountryCodeId(code.code, code.iso).toString(),
                name: `+${code.code} (${code.country})`,
              }))}
            onChange={(v) => {
              if (!v) return;
              const id = CountryCodeId.fromString(v);
              onChange({
                ...(value ?? createEmptyValue()),
                dialCode: id.dialCode,
                countryCode: id.letterCountryCode,
              });
            }}
          />
        </div>
        <div className={"flex-1"}>
          <TextInput
            hasError={!!errorMessage}
            placeholder="Il tuo numero di telefono"
            value={value?.number ?? ""}
            onChange={(v) => {
              onNumberChange?.();
              onChange({
                ...(value ?? createEmptyValue()),
                number: v.target.value ?? "",
              });
            }}
          />
        </div>
      </div>
      {errorMessage ? <p className={"text-red-500"}>{errorMessage}</p> : null}
    </div>
  );
}
